<jw-modal id='orderPriceListAddItemModal'>
  <h1 class='header'>Add from price list</h1>

  <div class='form-group'>
    @if (this.isError) {
      <div class="alert alert-danger">Please complete all required fields</div>
    }
    @if (this.isServerError) {
      <div class="alert alert-danger">Something went wrong. Please try again later.</div>
    }
    <div class='form-row col-md-4'>
      <label>Price List</label>
      <select class='form-control' (change)='onPriceListSelected($event)'>
        <option value='-1'>Select a price list</option>
        @for (priceList of priceLists; track priceList) {
          <option [value]='priceList.id'>{{ priceList.name }}</option>
        }
      </select>
    </div>
  </div>

  @if (this.priceListId !== -1) {
    <div class="form-row">
      <div class="form-group col-md-4">
        <label for="inputEmail4">Item</label>
        <select class='form-control' (change)='onItemSelected($event)'>
          <option value='-1'>Select an item</option>
          @for (item of this.items; track item) {
            <option [value]='item.id'>{{ item.name }}</option>
          }
        </select>
      </div>
      <div class="form-group col-md-4">
        <label for="inputEmail4">Qty</label>
        <input type="number" name='name' [(ngModel)]='this.orderLine.qty' [class.is-invalid]='!this.orderLine.qty' class="form-control" id="inputEmail4">
      </div>
      <div class="form-group col-md-4">
        <label for="inputEmail4">Unit</label>
        <select [class.is-invalid]='this.orderLine.unitId === -1'  class='form-control' (change)='this.orderLine.unitId = +$event.target.value'>
          <option selected value='-1'>Select a unit</option>
          @for (item of this.units; track item) {
            <option [selected]='this.orderLine.unitId === item.id' [value]='item.id'>{{ item.name }}</option>
          }
        </select>
      </div>
      <div class="form-group col-md-4">
        <label for="inputEmail4">Price</label>
        <input type="number" name='name' [(ngModel)]='this.orderLine.price' [class.is-invalid]='!this.orderLine.price' class="form-control" id="inputEmail4">
      </div>
    </div>
    <button type="submit" class="btn btn-success" (click)='this.onSubmit()'>Save</button>&nbsp;
    <button type="button" class="btn btn-danger" (click)='this.cancel()'>Cancel</button>
  }

</jw-modal>
